module.exports = __webpack_public_path__ + "media/images/products/demo/speaker-a7936d7286c9bc773208e07e03c40573.jpg";